import { createContext, useContext, useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  onAuthStateChanged,
  sendPasswordResetEmail
} from 'firebase/auth';
import {
  getDatabase,
  ref,
  set,
  get,
  update,
  push
} from "firebase/database";
import { getStorage} from "firebase/storage";

import axios from 'axios';

const firebaseConfig = {
  apiKey: "AIzaSyD8_yig9Ixqqo-aZ3Omo5tBXxNZGqvAbKI",
  authDomain: "fasto-e98a8.firebaseapp.com",
  databaseURL: "https://fasto-e98a8-default-rtdb.firebaseio.com",
  projectId: "fasto-e98a8",
  storageBucket: "fasto-e98a8.appspot.com",
  messagingSenderId: "186300117048",
  appId: "1:186300117048:web:b5e52bfba23a9bb8baf6cd",
  measurementId: "G-W1R4BR73LB"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();

const AuthContext = createContext();

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authToken, setAuthToken] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      if (user) {
        try {
          // For demo, use uid as token
          const token = user.uid;
          setAuthToken(token);
          //console.log(getUserData());
          // Fetch or create user profile
          const snapshot = await get(ref(database, `users/${token}`));
          if (snapshot.exists()) {
              setUserProfile(snapshot.val());
           } else {
              setUserProfile(null);
            }
          //setUserProfile(response.data);
        } catch (error) {
          console.error('Error fetching user profile:', error);
        }
      } else {
        setAuthToken(null);
        setUserProfile(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const signup = async (email, password) => {
    try {
      const result = await createUserWithEmailAndPassword(auth, email, password);
      return result.user;
    } catch (error) {
      throw error;
    }
  };

  const login = async (email, password) => {
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      return result.user;
    } catch (error) {
      throw error;
    }
  };

  const loginWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      return result.user;
    } catch (error) {
      throw error;
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      throw error;
    }
  };

  const resetPassword = async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
    } catch (error) {
      throw error;
    }
  };

  const createUserProfile = async (profileData) => {
    try {
      const token = authToken || currentUser.uid;
      await set(ref(database, `users/${token}`), profileData);
      setUserProfile(profileData);
      return profileData;
    } catch (error) {
      throw error;
    }
  };

  const updateProfile = async (data)=>{
    try {
      const token = authToken || currentUser.uid;
      await set(ref(database, `users/${data.uid}`), data);
      setUserProfile(profileData);
      return profileData;
    } catch (error) {
      throw error;
    }
  }
const getUserData = async (token1) => {
  try {
    const token = token1;

    if (!token) {
      console.error("No auth token found");
      return null;
    }

    const userRef = ref(database, `users/${token}`);
    const snapshot = await get(userRef);

    if (snapshot.exists()) {
      const userData = snapshot.val();
      setUserProfile(userData);
      console.log(userData);
      return userData;
    } else {
      console.log("User not found");
      return null;
    }

  } catch (error) {
    console.error("Error fetching user data:", error);
    return null;
  }
};


  const value = {
    currentUser,
    userProfile,
    authToken,
    loading,
    signup,
    login,
    loginWithGoogle,
    logout,
    resetPassword,
    createUserProfile
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};